/**
 * 跨 module 实例的「只装一次」工具。
 *
 * 利用 `Symbol.for(key)` 的全局 Symbol Registry —— 任何 module 用相同 key 拿到的
 * Symbol 是同一个引用。把标志挂在 `window[Symbol.for(key)]` 上后，即便宿主因为
 * pnpm hoist / peer dep 解析等原因加载了两份本 SDK 的 module，也只有第一次
 * 调用会执行 `install` 回调，避免 `pushState` / `fetch` / `XMLHttpRequest` /
 * `bridgeCallHandler` 等全局被叠层包裹（每次调用经过两层 wrapper）。
 *
 * 命名空间统一为 `@credit/insight-sdk:<key>`，避免和宿主或第三方库冲突。
 */
const NAMESPACE = "@credit/insight-sdk"

export const installOnce = (key: string, install: () => void): void => {
  const sym = Symbol.for(`${NAMESPACE}:${key}`)
  const w = window as unknown as Record<symbol, boolean>
  if (w[sym]) return
  // 先设 flag 再调用 install ——
  // 1. 防止 install 内部回调同步触发再次进入造成重入双装；
  // 2. 若 install 抛错也不重试（重试更可能扩大故障；且实践中 install
  //    都是 `window.fetch = wrapper` 这种几乎不会抛的赋值）。
  w[sym] = true
  install()
}
